import { useTranslation } from 'react-i18next';
import type { FormCheckboxType } from '#pie/components/form/types';
import { Stack } from '#pie/components/stack/Stack';
import {
  type CreateSimpleDataRequest,
  DataType,
} from '#pie/internal/api/pie-bff';
import { typedFormFields } from '#pie/utils/typedFormFields';

const { ConditionalField, FormCheckbox } =
  typedFormFields<CreateSimpleDataRequest>();

export const SimpleDataTypes = () => {
  //Welk type data wil je ontvangen?
  const { t } = useTranslation('dataRequest');
  const options: FormCheckboxType[] = [
    {
      label: t(`data_type.${DataType.Asset}`),
      tooltip: t(`data_type.tooltip.${DataType.Asset}`),
      value: DataType.Asset,
    },
    {
      label: t(`data_type.${DataType.Consumption}`),
      tooltip: t(`data_type.tooltip.${DataType.Consumption}`),
      value: DataType.Consumption,
    },
    {
      label: t(`data_type.${DataType.KeyFigures}`),
      value: DataType.KeyFigures,
    },
  ];

  const CreateFormCheckBox = () => {
    return (
      <Stack direction="column" gap="sm">
        <FormCheckbox
          name="dataTypes"
          label={t('data_types')}
          options={options}
          rules={{ required: true }}
        />
      </Stack>
    );
  };

  return (
    <ConditionalField
      field="dataTypes"
      condition={(formValue) => {
        return (
          !!formValue('dataRequestTo') && formValue('dataRequestTo')!.length > 0
        );
      }}
    >
      <CreateFormCheckBox />
    </ConditionalField>
  );
};
